import { get, post, postdownfile, del } from './http'
import store from '@/store/index.js'
//用户登陆
export const login = p => post('/token/issue/', p)
//主数据列表
export const masterList = p => post('/v1.0/master/list', p)
//编辑主数据
export const mastercreate = p => post('/v1.0/master/create', p)
//编辑主数据
export const masterUpdate = p => post('/v1.0/master/Update', p)
//主数据确认
export const masterConfirm = p => post('/v1.0/master/confirm/' + p)
//启用
export const masterEnable = p => post('/v1.0/master/enable/' + p)
//禁用
export const masterDisable = p => post('/v1.0/master/disable/' + p)
//主数据取消
export const masterReturn = p => post('/v1.0/master/return/' + p)
//系统配置列表
export const configurationList = p => get('/v1.0/configuration/list', p)
//获取类别
export const configurationtype = p => get('/v1.0/configuration/type', p)
//系统配置编辑
export const configurationCreateOrUpdate = p =>
  post('/v1.0/configuration/createOrUpdate', p)
//系统配置删除
export const configurationDelete = p =>
  del('/v1.0/configuration/' + +store.state.system.id, p)
//审查事件列表
export const logList = p => get('/v1.0/log/type', p)
//审计追踪列表
export const logQuery = p => post('/v1.0/log/query', p)
//导出
export const logexport = p => postdownfile('/v1.0/log/export', p)
//报表查询
export const reportQquery = p => post('/v1.0/report/query', p)
//报表导出
export const reportExport = p => postdownfile('/v1.0/report/export', p)
